export default __webpack_public_path__ + "static/media/document.3244f4ea.svg";